<template>
  <div style="background:#f4f6fa; padding:24px; min-height: 100vh;">
    <!-- 工作台顶栏 -->
    <div class="workbench-header">
      <div style="display:flex; align-items:center; gap:16px;">
        <a-button size="large" style="border-radius:6px;" @click="goBack">返回赛事</a-button>
        <div>
          <span style="color:#64748b; font-size:14px; display:block;">赛事管理工作台</span>
          <h2 style="margin:0; font-size:22px; font-weight:700; color:#0f172a;">
            {{ eventTitle || '赛事加载中...' }}
          </h2>
        </div>
      </div>
      <div v-if="eventInfo" style="display:flex; align-items:center; gap:8px;">
        <a-tag :color="statusColor(eventInfo.status)">{{ statusText(eventInfo.status) }}</a-tag>
        <span style="color:#64748b; font-size:14px;">地点：{{ eventInfo.location || '待定' }}</span>
      </div>
    </div>

    <!-- 工作台主体 Tab 页 -->
    <div class="workbench-content">
      <a-tabs :active-key="activeTabKey" size="large" :tabBarStyle="{ paddingLeft: '24px', margin: 0, borderBottom: '1px solid #f1f5f9' }" @change="onTabChange">
        <a-tab-pane key="category-config" tab="组别配置">
          <div style="padding:24px;">
            <div style="margin-bottom:20px; display:flex; justify-content:flex-end; align-items:center;">
              <a-button type="primary" style="border-radius:6px;" @click="handleAddCategory">新增组别</a-button>
            </div>
            
            <a-table
              rowKey="id"
              :columns="categoryColumns"
              :data-source="categories"
              :loading="categoryLoading"
              :pagination="false"
              style="background:#fff;"
            >
              <span slot="status" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '禁用' }}</a-tag>
              </span>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEditCategory(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除此组别吗？这会级联清除此组别相关的成绩配置！" ok-text="确定" cancel-text="取消" @confirm="handleDeleteCategory(record.id)">
                  <a style="color:red;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="stage-config" tab="阶段配置">
          <div style="padding:24px;">
            <div style="margin-bottom:20px; display:flex; justify-content:flex-end; align-items:center;">
              <a-button type="primary" style="border-radius:6px;" @click="handleAddStage">新增阶段</a-button>
            </div>
            <a-table
              rowKey="id"
              :columns="stageColumns"
              :data-source="stageOptions"
              :loading="stageLoading"
              :pagination="false"
              style="background:#fff;"
            >
              <span slot="status" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '停用' }}</a-tag>
              </span>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEditStage(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除此阶段吗？" ok-text="确定" cancel-text="取消" @confirm="handleDeleteStage(record.id)">
                  <a style="color:red;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="distance-config" tab="距离配置">
          <div style="padding:24px;">
            <div style="margin-bottom:20px; display:flex; justify-content:flex-end; align-items:center;">
              <a-button type="primary" style="border-radius:6px;" @click="handleAddDistance">新增距离</a-button>
            </div>
            <a-table
              rowKey="id"
              :columns="distanceColumns"
              :data-source="distanceOptions"
              :loading="distanceLoading"
              :pagination="false"
              style="background:#fff;"
            >
              <span slot="distance" slot-scope="text">{{ text }} 米</span>
              <span slot="status" slot-scope="text">
                <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '停用' }}</a-tag>
              </span>
              <span slot="action" slot-scope="text, record">
                <a @click="handleEditDistance(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除此距离吗？" ok-text="确定" cancel-text="取消" @confirm="handleDeleteDistance(record.id)">
                  <a style="color:red;">删除</a>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="registration-review" tab="队伍与报名">
          <div style="padding:16px 24px 24px;">
            <div style="margin-bottom:16px; display:flex; justify-content:flex-end;">
              <a-button type="primary" icon="plus" style="border-radius:6px;" @click="handleAddEventTeam">添加队伍</a-button>
            </div>
            <dragon-registration :key="registrationReloadKey" :event-id="Number(eventId)" embedded />
          </div>
        </a-tab-pane>

        <a-tab-pane key="results-quick-entry" tab="录入成绩">
          <!-- 筛选排版 -->
          <div class="filter-bar">
            <div style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;">
              <div>
                <span class="filter-label">组别</span>
                <a-select v-model="filter.categoryId" allowClear placeholder="全部组别" style="width:180px;" @change="handleFilterChange">
                  <a-select-option v-for="item in categories" :key="item.id" :value="item.id">
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </div>

              <div>
                <span class="filter-label">阶段</span>
                <a-select v-model="filter.roundName" allowClear placeholder="全部阶段" style="width:140px;" @change="handleFilterChange">
                  <a-select-option v-for="item in activeStageOptions" :key="item.stageName" :value="item.stageName">
                    {{ item.stageName }}
                  </a-select-option>
                </a-select>
              </div>

              <div>
                <span class="filter-label">距离</span>
                <a-select v-model="filter.distance" allowClear placeholder="全部距离" style="width:140px;" @change="handleFilterChange">
                  <a-select-option v-for="item in activeDistanceOptions" :key="item.distance" :value="item.distance">
                    {{ item.distance }} 米
                  </a-select-option>
                </a-select>
              </div>

              <a-button type="primary" style="margin-top:20px;" @click="loadRoundsAndResults">查询</a-button>
            </div>

            <!-- 控制按钮组 -->
            <div style="display:flex; gap:8px; margin-top:20px;">
              <a-button type="primary" icon="save" :loading="allSaving" @click="handleSaveAllRounds">
                保存全部
              </a-button>
              <a-button icon="sort-ascending" @click="handleSortRoundsByTime">
                {{ timeSortOrder === 'asc' ? '时间正序' : '时间倒序' }}
              </a-button>
              <a-button type="primary" class="btn-success" @click="handleAddNewRound">
                添加
              </a-button>
               <a-button icon="download" @click="downloadWorkbookTemplate">
                 下载模板
               </a-button>
               <a-button icon="export" @click="handleExportResults" :loading="exporting">
                 导出成绩
               </a-button>
              <a-upload
                :customRequest="handleWorkbookImport"
                :showUploadList="false"
                accept=".xls,.xlsx"
                style="display:inline-block;"
              >
                <a-button type="primary" icon="upload" :loading="importing" title="上传成绩文件"></a-button>
              </a-upload>
            </div>
          </div>

          <!-- 分组卡片列表（大格子） -->
          <div style="padding:24px; background:#f8fafc; min-height:400px;">
            <div v-if="roundCards.length > 0">
              <div v-for="round in roundCards" :key="round.id || round.tempId" class="round-card-box">
                <!-- 大格子头部 -->
                <div class="round-card-header">
                  <div class="header-left">
                    <span class="group-badge">{{ round.id ? `第 ${round.roundOrder} 组` : '新增比赛组' }}</span>
                    <span class="group-title">{{ getRoundTitle(round) }}</span>
                  </div>
                  
                  <div class="header-right">
                    <!-- 时间 -->
                    <div class="meta-field">
                      <span class="meta-label">时间</span>
                      <a-date-picker
                        v-model="round.roundTimeStr"
                        show-time
                        format="YYYY-MM-DD HH:mm"
                        value-format="YYYY-MM-DD HH:mm"
                        placeholder="选择比赛时间"
                        style="width:170px;"
                      />
                    </div>
                    <!-- 组别 -->
                    <div class="meta-field">
                      <span class="meta-label">组别</span>
                      <a-select v-model="round.categoryId" style="width:140px;" @change="() => handleRoundCategoryChange(round)">
                        <a-select-option v-for="item in categories" :key="item.id" :value="item.id">
                          {{ item.categoryName }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <!-- 阶段 -->
                    <div class="meta-field">
                      <span class="meta-label">阶段</span>
                      <a-select v-model="round.roundName" style="width:110px;">
                        <a-select-option v-for="item in activeStageOptions" :key="item.stageName" :value="item.stageName">
                          {{ item.stageName }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <!-- 距离 -->
                    <div class="meta-field">
                      <span class="meta-label">距离</span>
                      <a-select v-model="round.distance" style="width:110px;">
                        <a-select-option v-for="item in activeDistanceOptions" :key="item.distance" :value="item.distance">
                          {{ item.distance }} 米
                        </a-select-option>
                      </a-select>
                    </div>
                    <!-- 状态 -->
                    <div class="meta-field">
                      <span class="meta-label">状态</span>
                      <a-select v-model="round.status" style="width:110px;">
                        <a-select-option :value="0">准备中</a-select-option>
                        <a-select-option :value="1">进行中</a-select-option>
                        <a-select-option :value="2">已结束</a-select-option>
                      </a-select>
                    </div>
                    <!-- 备注 -->
                    <div class="meta-field">
                      <a-input v-model="round.description" placeholder="本组备注：如重赛、风浪、改道" style="width:240px;" />
                    </div>

                    <a-button type="primary" size="small" @click="handleAddNewResultRow(round)">添加</a-button>
                    <a-popconfirm title="确定删除本组成绩吗？该组下成绩也会一并删除。" ok-text="确定" cancel-text="取消" @confirm="handleDeleteRound(round)">
                      <a-button size="small" class="btn-round-delete">删除</a-button>
                    </a-popconfirm>
                  </div>
                </div>

                <!-- 大格子表格主体 -->
                <div class="round-table-container">
                  <table class="rapid-entry-table">
                    <thead>
                      <tr>
                        <th style="width: 100px;">名次</th>
                        <th style="width: 100px;">航道</th>
                        <th>队伍/单位</th>
                        <th style="width: 140px;">编号</th>
                        <th style="width: 160px;">成绩</th>
                        <th style="width: 120px;">差值</th>
                        <th style="width: 180px;">状态</th>
                        <th style="width: 260px;">备注</th>
                        <th style="width: 90px; text-align:center;">操作</th>
                      </tr>
                    </thead>
                    <draggable
                      v-model="round.results"
                      tag="tbody"
                      handle=".drag-handle"
                      @end="handleResultDragEnd(round)"
                    >
                      <tr v-for="(row, rowIdx) in round.results" :key="row.id || row.tempId || rowIdx" :class="{ 'row-foul-dns': row.isFoul || row.isDns }">
                        <!-- 名次 -->
                        <td>
                          <span class="rank-badge" :class="rankBadgeClass(row.rankNo)">
                            {{ formatRankNo(row.rankNo, row.isFoul || row.isDns) }}
                          </span>
                        </td>
                        <!-- 航道号 -->
                        <td>
                          <a-input-number v-model="row.laneNo" :min="1" style="width:100%; text-align:center;" />
                        </td>
                        <!-- 队伍/单位 (限制只能添加已报名的队伍) -->
                        <td>
                          <a-select
                            v-model="row.teamId"
                            show-search
                            placeholder="输入或选择参赛队"
                            option-filter-prop="children"
                            style="width: 100%;"
                            @change="(val) => handleRowTeamChange(row, val, round)"
                          >
                            <a-select-option v-for="team in round.participantTeams" :key="team.teamId" :value="team.teamId">
                              {{ team.teamName }}
                            </a-select-option>
                          </a-select>
                        </td>
                        <!-- 参赛编号 -->
                        <td>
                          <a-input v-model="row.bibNo" placeholder="编号" />
                        </td>
                        <!-- 成绩 -->
                        <td>
                          <a-input
                            v-model="row.resultTime"
                            placeholder="例如 2:11.32"
                            :disabled="row.isFoul || row.isDns"
                            @change="handleRecalculateRound(round, false)"
                          />
                        </td>
                        <!-- 差值 -->
                        <td>
                          <span :class="gapTimeClass(row.rankNo, row.isFoul || row.isDns)">
                            {{ formatGapText(row.gapTime, row.isFoul || row.isDns) }}
                          </span>
                        </td>
                        <!-- 状态 (犯规/DNS) -->
                        <td>
                          <a-checkbox v-model="row.isFoul" @change="handleRowStatusChange(row, 'foul', round)">犯规</a-checkbox>
                          <a-checkbox v-model="row.isDns" @change="handleRowStatusChange(row, 'dns', round)">DNS</a-checkbox>
                        </td>
                        <!-- 备注 -->
                        <td>
                          <a-input v-model="row.remark" placeholder="备注信息" style="width:100%;" />
                        </td>
                        <!-- 操作 -->
                        <td class="row-action-cell">
                          <a-icon type="drag" class="drag-handle" title="拖动调整顺序" />
                          <a-icon type="delete" style="color:red; cursor:pointer; font-size:16px;" @click="handleRemoveRow(round, rowIdx)" />
                        </td>
                      </tr>
                    </draggable>
                    <tbody v-if="round.results.length === 0">
                      <tr v-if="round.results.length === 0">
                        <td colspan="9" style="text-align:center; padding: 24px 0; color:#94a3b8;">
                          暂无队伍，请点击右上角“添加”排定航道。
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- 大格子底部动作 -->
                <div class="round-card-footer">
                  <div class="footer-left">
                    <span style="margin-right:16px;">最快成绩：<strong>{{ getRoundFastestTime(round) }}</strong></span>
                    <span>已录队伍：<strong>{{ round.results.length }}</strong></span>
                  </div>
                  <div class="footer-right">
                    <a-button size="small" style="border-radius:6px;" @click="openRoundLineup(round)">坐舱名单</a-button>
                  </div>
                </div>
              </div>
            </div>

            <div v-else style="padding: 80px 0; text-align: center; background: #fff; border-radius: 12px;">
              <a-empty description="暂无比赛组，请点击上方“添加”录入。" />
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="scoring-board" tab="积分榜">
          <dragon-scoring :event-id="Number(eventId)" embedded />
        </a-tab-pane>
      </a-tabs>
    </div>

    <!-- 坐舱名单模态框 -->
    <a-modal v-model="lineupVisible" :title="lineupTitle" width="760px" :footer="null">
      <div v-if="lineupTeams.length" class="lineup-layout">
        <!-- 左侧：队伍列表 -->
        <div class="lineup-team-list">
          <div class="lineup-team-item"
            :class="{ active: activeLineupTeam && activeLineupTeam.registrationId === team.registrationId }"
            v-for="team in lineupTeams" :key="team.registrationId" @click="activeLineupTeam = team">
            <div class="lineup-team-name">{{ team.teamName || '未命名队伍' }}</div>
            <div class="lineup-team-meta">
              <span v-if="team.laneNo">第{{ team.laneNo }}航道</span>
              <span v-if="team.bibNo">编号 {{ team.bibNo }}</span>
              <span v-else style="color:#CBDCE4;">未分配编号</span>
            </div>
          </div>
        </div>
        <!-- 右侧：单队伍座位图 -->
        <div class="lineup-boat" v-if="activeLineupTeam">
          <div class="boat-head">船 头</div>
          <div class="boat-row" v-for="row in adminBoatRows" :key="'row' + row.rowNo">
            <div class="boat-seat" v-for="seat in row.seats" :key="seat.seatOrder">
              <div class="boat-avatar">{{ seat.member ? seat.member.memberName[0] : '空' }}</div>
              <div class="boat-seat-name">{{ seat.member ? seat.member.memberName : '空位' }}</div>
              <div class="boat-seat-pos">{{ seat.member ? row.rowNo + '行' + seat.sideText : '' }}</div>
              <a-tag v-if="seat.member && seat.member.isLeader === 1" color="cyan" style="margin-top:4px;">领队</a-tag>
            </div>
          </div>
          <div class="boat-tail">船 尾</div>
          <div class="boat-alternates" v-if="activeLineupTeam.alternateMembers && activeLineupTeam.alternateMembers.length">
            <div class="boat-alt-title">替补</div>
            <div class="boat-alt-item" v-for="(m, i) in activeLineupTeam.alternateMembers" :key="'a' + i">{{ i + 1 }}. {{ m.memberName }}</div>
          </div>
          <div class="boat-empty" v-if="!activeLineupTeam.seatMembers.length">该队本轮未安排座舱</div>
        </div>
      </div>
      <div v-if="!lineupTeams.length" style="text-align:center; color:#999; padding:30px 0;">该轮暂无通过审核的报名队伍</div>
    </a-modal>

    <!-- 组别新增/编辑模态框 -->
    <a-modal v-model="categoryVisible" :title="categoryForm.id ? '编辑组别' : '新增组别'" @ok="handleSaveCategory" width="560px" destroyOnClose>
      <a-form-model ref="categoryFormRef" :model="categoryForm" :rules="categoryRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="组别名称" prop="categoryName">
          <a-input v-model="categoryForm.categoryName" placeholder="例如：公开组、男子组、混合组" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sortOrder">
          <a-input-number v-model="categoryForm.sortOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="categoryForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 添加队伍模态框 -->
    <a-modal v-model="teamVisible" title="添加队伍" @ok="handleSaveEventTeam" width="560px" destroyOnClose>
      <a-form-model :model="teamForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="参赛组别">
          <a-select v-model="teamForm.categoryId" placeholder="请选择组别">
            <a-select-option v-for="item in categories" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择队伍">
          <a-select v-model="teamForm.teamId" show-search placeholder="选择队伍管理中的已审核队伍" option-filter-prop="children">
            <a-select-option v-for="item in availableTeamOptions" :key="item.id" :value="item.id">{{ item.teamName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="参赛编号">
          <a-input v-model="teamForm.bibNo" placeholder="可选" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 阶段新增/编辑模态框 -->
    <a-modal v-model="stageVisible" :title="stageForm.id ? '编辑阶段' : '新增阶段'" @ok="handleSaveStage" width="560px" destroyOnClose>
      <a-form-model :model="stageForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="阶段名称">
          <a-input v-model="stageForm.stageName" placeholder="例如：预赛、半决赛、决赛" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="stageForm.stageOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="stageForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 距离新增/编辑模态框 -->
    <a-modal v-model="distanceVisible" :title="distanceForm.id ? '编辑距离' : '新增距离'" @ok="handleSaveDistance" width="560px" destroyOnClose>
      <a-form-model :model="distanceForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="比赛距离">
          <a-input-number v-model="distanceForm.distance" :min="1" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="distanceForm.distanceOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="distanceForm.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {
  addDragonRegistrationTeam,
  auditDragonRegistration,
  deleteDragonRegistration,
  deleteDragonDistanceConfig,
  deleteDragonRound,
  deleteDragonStageConfig,
  getDragonEventDetail,
  getDragonCategoryList,
  saveDragonCategory,
  deleteDragonCategory,
  getDragonRegistrationList,
  getDragonRegistrationRoundLineups,
  getDragonRoundList,
  saveDragonRound,
  getDragonResultList,
  getDragonResultTeamOptions,
  batchSaveDragonResults,
  importDragonResultWorkbook,
  exportDragonResults,
  getDragonDistanceConfigList,
  getDragonStageConfigList,
  getDragonTeamList,
  saveDragonDistanceConfig,
  saveDragonStageConfig
} from '@/api'

export default {
  components: {
    draggable,
    DragonRegistration: () => import('@/views/dragonboat/registration/index.vue'),
    DragonScoring: () => import('@/views/dragonboat/scoring/index.vue')
  },
  computed: {
    activeStageOptions() {
      return this.stageOptions.filter(item => item.status === 1)
    },
    activeDistanceOptions() {
      return this.distanceOptions.filter(item => item.status === 1)
    },
    availableTeamOptions() {
      const usedTeamIds = this.eventTeams.map(item => item.teamId)
      return this.teamOptions.filter(item => !usedTeamIds.includes(item.id))
    },
    adminBoatRows() {
      const team = this.activeLineupTeam
      if (!team) return []
      const rows = this.boatSeatRows || []
      const members = (team.seatMembers || []).slice().sort((a, b) => (a.seatOrder || 0) - (b.seatOrder || 0))
      const memberMap = {}
      members.forEach(m => { memberMap[m.seatOrder] = m })
      const totalSeats = rows.reduce((sum, n) => sum + (Number(n) || 0), 0)
      const boatRows = []
      let seatCursor = 1
      rows.forEach((count, i) => {
        const countNum = Number(count) || 0
        const seats = []
        for (let j = 0; j < countNum; j++) {
          const m = memberMap[seatCursor] || null
          seats.push({
            seatOrder: seatCursor,
            member: m,
            sideText: countNum === 1 ? '中间' : j === 0 ? '左' : '右',
            positionRole: seatCursor === 1 ? '鼓手' : seatCursor === totalSeats ? '舵手' : (m && m.positionRole) || ''
          })
          seatCursor++
        }
        boatRows.push({ rowNo: i + 1, seats })
      })
      return boatRows
    }
  },
  data() {
    return {
      activeTabKey: 'registration-review',
      eventId: undefined,
      eventInfo: null,
      eventTitle: '',
      
      filter: {
        categoryId: undefined,
        roundName: undefined,
        distance: undefined
      },
      
      // 赛事队伍配置
      eventTeams: [],
      registrationReloadKey: 0,
      teamOptions: [],
      teamLoading: false,
      teamVisible: false,
      teamForm: {},
      teamColumns: [
        { title: '组别', dataIndex: 'categoryName', width: 160 },
        { title: '队伍', dataIndex: 'teamName', width: 220 },
        { title: '编号', dataIndex: 'bibNo', width: 120 },
        { title: '状态', dataIndex: 'auditStatus', width: 120, scopedSlots: { customRender: 'auditStatus' } },
        { title: '备注', dataIndex: 'auditRemark' },
        { title: '操作', key: 'action', width: 180, scopedSlots: { customRender: 'action' } }
      ],

      // 阶段配置
      stageOptions: [],
      stageLoading: false,
      stageVisible: false,
      stageForm: {},
      stageColumns: [
        { title: '阶段名称', dataIndex: 'stageName', width: 180 },
        { title: '排序', dataIndex: 'stageOrder', width: 100 },
        { title: '状态', dataIndex: 'status', width: 120, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ],

      // 距离配置
      distanceOptions: [],
      distanceLoading: false,
      distanceVisible: false,
      distanceForm: {},
      distanceColumns: [
        { title: '比赛距离', dataIndex: 'distance', width: 160, scopedSlots: { customRender: 'distance' } },
        { title: '排序', dataIndex: 'distanceOrder', width: 100 },
        { title: '状态', dataIndex: 'status', width: 120, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ],

      // 大格子列表
      roundCards: [],
      loading: false,
      importing: false,
      exporting: false,
      allSaving: false,
      timeSortOrder: 'desc',

      // 组别配置
      categories: [],
      categoryLoading: false,
      categoryVisible: false,
      lineupVisible: false,
      lineupTitle: '坐舱名单',
      lineupTeams: [],
      activeLineupTeam: null,
      boatSeatRows: [],
      lineupColumns: [
        { title: '队伍', dataIndex: 'teamName', width: 160 },
        { title: '航道', dataIndex: 'laneNo', width: 70 },
        { title: '编号', dataIndex: 'bibNo', width: 80 },
        { title: '座舱成员', key: 'seatMembers', scopedSlots: { customRender: 'seatMembers' } },
        { title: '替补', key: 'alternates', scopedSlots: { customRender: 'alternates' } }
      ],
      categoryForm: {
        status: 1,
        sortOrder: 0
      },
      categoryRules: {
        categoryName: [{ required: true, message: '请输入组别名称', trigger: 'blur' }]
      },
      categoryColumns: [
        { title: '组别名称', dataIndex: 'categoryName', width: 220 },
        { title: '排序', dataIndex: 'sortOrder', width: 100 },
        { title: '状态', dataIndex: 'status', width: 120, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    const urlTab = this.$route.query.tab
    this.activeTabKey = urlTab || 'registration-review'
    this.eventId = Number(this.$route.query.eventId)
    if (!this.eventId) {
      this.$message.error('未指定赛事ID')
      this.goBack()
      return
    }
    this.loadEventDetail()
    this.loadStageConfigs()
    this.loadDistanceConfigs()
    this.loadTeamConfig()
    this.loadTeamOptions()
    this.loadCategories().then(() => {
      this.loadRoundsAndResults()
    })
  },
  methods: {
    // 切换 Tab 时记录到 URL，刷新后保持当前页
    onTabChange(key) {
      this.activeTabKey = key
      this.$router.replace({ query: { ...this.$route.query, tab: key } })
    },
    goBack() {
      this.$router.push('/dragonboat/event')
    },
    loadEventDetail() {
      getDragonEventDetail({ id: this.eventId }).then(res => {
        if (res.data) {
          this.eventInfo = res.data.event
          this.eventTitle = this.eventInfo ? this.eventInfo.title : ''
        }
      })
    },
    loadCategories() {
      this.categoryLoading = true
      return getDragonCategoryList({ eventId: this.eventId }).then(res => {
        this.categories = (res.data && res.data.list) || []
      }).finally(() => {
        this.categoryLoading = false
      })
    },
    loadStageConfigs() {
      this.stageLoading = true
      return getDragonStageConfigList({ eventId: this.eventId }).then(res => {
        this.stageOptions = (res.data && res.data.list) || []
      }).finally(() => {
        this.stageLoading = false
      })
    },
    loadDistanceConfigs() {
      this.distanceLoading = true
      return getDragonDistanceConfigList({ eventId: this.eventId }).then(res => {
        this.distanceOptions = (res.data && res.data.list) || []
      }).finally(() => {
        this.distanceLoading = false
      })
    },
    loadTeamConfig() {
      this.teamLoading = true
      return getDragonRegistrationList({
        page: 1,
        pageSize: 500,
        eventId: this.eventId
      }).then(res => {
        this.eventTeams = (res.data && res.data.list) || []
      }).finally(() => {
        this.teamLoading = false
      })
    },
    loadTeamOptions() {
      return getDragonTeamList({ page: 1, pageSize: 500, auditStatus: 1 }).then(res => {
        this.teamOptions = (res.data && res.data.list) || []
      })
    },

    loadRoundsAndResults() {
      this.loading = true

      const params = {
        eventId: this.eventId,
        page: 1,
        pageSize: 500,
        categoryId: this.filter.categoryId
      }
      
      getDragonRoundList(params).then(res => {
        const rawRounds = (res.data && res.data.list) || []
        // 筛选条件为空时展示总表，有值时按条件缩小范围。
        const filtered = rawRounds.filter(item => {
          const matchStage = !this.filter.roundName || item.roundName === this.filter.roundName
          const matchDistance = !this.filter.distance || parseInt(item.distance) === parseInt(this.filter.distance)
          return matchStage && matchDistance
        })

        const promises = filtered.map(round => {
          this.$set(round, 'publishing', false)
          this.$set(round, 'results', [])
          this.$set(round, 'participantTeams', [])
          // 格式化时间便于展示 (把 2026-05-27 09:00:00 -> 2026-05-27 09:00)
          this.$set(round, 'roundTimeStr', round.roundTime ? round.roundTime.slice(0, 16).replace('T', ' ') : '')

          const teamPromise = this.loadRoundParticipantTeams(round)
          const resultPromise = getDragonResultList({ roundId: round.id, page: 1, pageSize: 100 }).then(resultRes => {
            const list = resultRes.data.list || []
            list.forEach(row => {
              this.$set(row, 'isFoul', row.remark === '犯规' || row.resultTime === '犯规')
              this.$set(row, 'isDns', row.remark === 'DNS' || row.resultTime === 'DNS')
            })
            list.sort((a, b) => this.compareResultRows(a, b))
            round.results = list
            this.$set(round, 'published', list.some(row => row.published === 1) ? 1 : 0)
          })
          return Promise.all([teamPromise, resultPromise])
        })

        Promise.all(promises).then(() => {
          this.sortRoundCardsByTime(filtered, this.timeSortOrder)
          this.roundCards = filtered
        })
      }).finally(() => {
        this.loading = false
      })
    },

    handleFilterChange() {
      this.loadRoundsAndResults()
    },

    compareResultRows(a, b) {
      const rankA = this.hasEffectiveRank(a.rankNo)
      const rankB = this.hasEffectiveRank(b.rankNo)
      if (rankA || rankB) {
        if (rankA !== rankB) {
          return rankA ? -1 : 1
        }
        const rankNoA = Number(a.rankNo)
        const rankNoB = Number(b.rankNo)
        if (rankNoA !== rankNoB) {
          return rankNoA - rankNoB
        }
      }
      const laneA = a.laneNo || 999999
      const laneB = b.laneNo || 999999
      if (laneA !== laneB) {
        return laneA - laneB
      }
      const sortA = a.sortOrder || 999999
      const sortB = b.sortOrder || 999999
      if (sortA !== sortB) {
        return sortA - sortB
      }
      return (a.id || 0) - (b.id || 0)
    },

    hasEffectiveRank(rankNo) {
      const rank = Number(rankNo)
      return Number.isFinite(rank) && rank > 0 && rank < 99
    },

    sortRoundResults(round) {
      if (!round || !round.results) return
      round.results.sort((a, b) => this.compareResultRows(a, b))
      round.results.forEach((row, index) => {
        this.$set(row, 'sortOrder', index + 1)
      })
    },

    sortRoundCardsByTime(list, order) {
      list.sort((a, b) => {
        const timeA = a.roundTimeStr || (a.roundTime ? String(a.roundTime).slice(0, 16).replace('T', ' ') : '')
        const timeB = b.roundTimeStr || (b.roundTime ? String(b.roundTime).slice(0, 16).replace('T', ' ') : '')
        if (timeA !== timeB) {
          return order === 'asc' ? String(timeA).localeCompare(String(timeB)) : String(timeB).localeCompare(String(timeA))
        }
        const orderA = a.roundOrder || 0
        const orderB = b.roundOrder || 0
        return order === 'asc' ? orderA - orderB : orderB - orderA
      })
    },

    handleSortRoundsByTime() {
      const order = this.timeSortOrder === 'asc' ? 'desc' : 'asc'
      this.timeSortOrder = order
      this.sortRoundCardsByTime(this.roundCards, order)
      this.$message.success(order === 'asc' ? '已按比赛时间正序排列' : '已按比赛时间倒序排列')
    },

    downloadWorkbookTemplate() {
      window.open(`${process.env.BASE_URL}templates/dragonboat-result-workbook-import-template-required.xlsx`)
    },

    handleExportResults() {
      if (this.exporting) return
      this.exporting = true
      exportDragonResults({ eventId: this.eventId }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `成绩导出_${new Date().toISOString().slice(0, 10)}.xlsx`
        link.click()
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(() => {}).finally(() => { this.exporting = false })
    },

    handleWorkbookImport({ file, onSuccess, onError }) {
      if (this.importing) {
        onError(new Error('正在导入中'))
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      this.importing = true
      importDragonResultWorkbook(this.eventId, formData).then(res => {
        const data = res.data || {}
        this.$message.success(`导入成功：比赛组 ${data.roundCount || 0} 个，成绩 ${data.resultCount || 0} 条，新增组别 ${data.categoryCount || 0} 个、阶段 ${data.stageCount || 0} 个、距离 ${data.distanceCount || 0} 个，新增外部队伍 ${data.externalTeamCount || 0} 个`)
        this.loadTeamConfig()
        this.loadTeamOptions()
        this.loadCategories()
        this.loadStageConfigs()
        this.loadDistanceConfigs()
        this.loadRoundsAndResults()
        onSuccess(res)
      }).catch(err => {
        onError(err)
      }).finally(() => {
        this.importing = false
      })
    },

    loadRoundParticipantTeams(round) {
      if (!round.categoryId) {
        this.$set(round, 'participantTeams', [])
        return Promise.resolve()
      }
      return getDragonResultTeamOptions({ eventId: this.eventId, categoryId: round.categoryId }).then(res => {
        this.$set(round, 'participantTeams', (res.data && res.data.list) || [])
      })
    },

    // 航道内队伍选择改变，自动回填 teamName
    handleRowTeamChange(row, teamId, round) {
      const team = ((round && round.participantTeams) || []).find(t => t.teamId === teamId)
      if (team) {
        row.teamName = team.teamName
      }
    },

    handleRoundCategoryChange(round) {
      this.loadRoundParticipantTeams(round)
      round.results.forEach(row => {
        row.categoryId = round.categoryId
        row.teamId = undefined
        row.teamName = ''
      })
    },

    // 勾选犯规/DNS
    handleRowStatusChange(row, type, round) {
      if (type === 'foul' && row.isFoul) {
        row.isDns = false
        row.resultTime = '犯规'
        row.remark = '犯规'
        row.rankNo = 99
        row.gapTime = '--'
      } else if (type === 'dns' && row.isDns) {
        row.isFoul = false
        row.resultTime = 'DNS'
        row.remark = 'DNS'
        row.rankNo = 99
        row.gapTime = '--'
      } else {
        row.resultTime = ''
        row.remark = ''
        row.rankNo = undefined
        row.gapTime = ''
      }
      if (round) {
        this.handleRecalculateRound(round, false)
      }
    },

    // 添加队伍成绩行
    handleAddNewResultRow(round) {
      if (!round.categoryId) {
        this.$message.warning('请先选择组别')
        return
      }
      round.results.push({
        tempId: `row_${Date.now()}_${round.results.length}`,
        eventId: parseInt(this.eventId),
        categoryId: round.categoryId,
        roundId: round.id,
        laneNo: round.results.length + 1,
        teamId: undefined,
        teamName: '',
        bibNo: '',
        resultTime: '',
        rankNo: undefined,
        gapTime: '',
        published: 0,
        remark: '',
        isFoul: false,
        isDns: false
      })
    },

    // 移除行
    handleRemoveRow(round, idx) {
      round.results.splice(idx, 1)
      // 重新排航道号
      round.results.forEach((row, i) => {
        row.laneNo = i + 1
      })
    },

    handleResultDragEnd(round) {
      round.results.forEach((row, index) => {
        this.$set(row, 'sortOrder', index + 1)
      })
    },

    handleRecalculateRound(round, showMessage = true) {
      const results = round.results
      if (results.length === 0) return

      // 1. 将有效的成绩解析成秒数进行排序
      const tempRows = results.map((row, idx) => {
        let seconds = Infinity
        const isInvalid = row.isFoul || row.isDns || !row.resultTime || row.resultTime === '犯规' || row.resultTime === 'DNS'
        if (!isInvalid) {
          seconds = this.parseTimeToSeconds(row.resultTime)
        }
        return { idx, seconds, isInvalid, rawTime: row.resultTime }
      })

      // 找出最快完赛秒数
      let minSeconds = Infinity
      tempRows.forEach(item => {
        if (!item.isInvalid && item.seconds < minSeconds) {
          minSeconds = item.seconds
        }
      })

      // 2. 排序有效完赛的队伍计算名次
      const validFinished = tempRows
        .filter(item => !item.isInvalid && item.seconds !== Infinity)
        .sort((a, b) => a.seconds - b.seconds)

      // 设定名次 (处理并列名次的情况)
      let currentRank = 1
      validFinished.forEach((item, i) => {
        if (i > 0 && item.seconds > validFinished[i - 1].seconds) {
          currentRank = i + 1
        }
        results[item.idx].rankNo = currentRank
      })

      // 3. 计算每一行差值和回填
      results.forEach((row, index) => {
        const tInfo = tempRows.find(t => t.idx === index)
        if (row.isFoul || row.isDns) {
          row.rankNo = 99
          row.gapTime = '--'
        } else if (tInfo.seconds === Infinity) {
          row.rankNo = undefined
          row.gapTime = '--'
        } else {
          // 第一名显示自身成绩，其他显示差值时间
          if (tInfo.seconds === minSeconds) {
            row.gapTime = row.resultTime
          } else {
            const diff = tInfo.seconds - minSeconds
            row.gapTime = `+${diff.toFixed(2)}`
          }
        }
      })
      this.sortRoundResults(round)

      if (showMessage) {
        this.$message.success('计算完成')
      }
    },

    // 辅助解析时间字符为秒
    parseTimeToSeconds(timeStr) {
      if (!timeStr) return Infinity
      const str = String(timeStr).trim()
      if (!str) return Infinity
      if (str.includes(':')) {
        const parts = str.split(':')
        const min = parseFloat(parts[0]) || 0
        const sec = parseFloat(parts[1]) || 0
        return min * 60 + sec
      }
      return parseFloat(str) || Infinity
    },

    // 渲染统计：本组最快成绩
    getRoundFastestTime(round) {
      let fastest = '-'
      let minSec = Infinity
      round.results.forEach(row => {
        const isInvalid = row.isFoul || row.isDns || !row.resultTime || row.resultTime === '犯规' || row.resultTime === 'DNS'
        if (!isInvalid) {
          const sec = this.parseTimeToSeconds(row.resultTime)
          if (sec < minSec) {
            minSec = sec
            fastest = row.resultTime
          }
        }
      })
      return fastest
    },

    validateRoundBeforeSave(round, index) {
      const label = round.roundOrder ? `第 ${round.roundOrder} 组` : `第 ${index + 1} 个比赛组`
      if (!round.categoryId) {
        this.$message.warning(`${label}：请选择组别`)
        return false
      }
      if (!round.roundName) {
        this.$message.warning(`${label}：请选择阶段`)
        return false
      }
      if (!round.distance) {
        this.$message.warning(`${label}：请选择距离`)
        return false
      }
      if (!round.roundTimeStr) {
        this.$message.warning(`${label}：请输入比赛时间`)
        return false
      }
      return true
    },

    buildRoundSavePayload(round) {
      this.handleRecalculateRound(round, false)
      this.sortRoundResults(round)

      round.roundTime = `${round.roundTimeStr}:00`

      const nextOrder = round.roundOrder || this.getNextRoundOrder()
      const roundPayload = {
        id: round.id,
        eventId: round.eventId || parseInt(this.eventId),
        categoryId: round.categoryId,
        roundName: round.roundName,
        roundCode: round.roundCode,
        roundOrder: nextOrder,
        roundTime: round.roundTime,
        status: round.status == null ? 0 : round.status,
        distance: round.distance,
        description: round.description
      }

      const buildBatchPayload = savedRound => ({
        roundId: savedRound.id,
          results: round.results.map((row, index) => ({
            eventId: row.eventId || parseInt(this.eventId),
            categoryId: round.categoryId,
            roundId: savedRound.id,
            laneNo: row.laneNo,
            teamId: row.teamId,
            teamName: row.teamName,
            bibNo: row.bibNo,
            resultTime: row.resultTime,
            rankNo: row.rankNo,
            sortOrder: index + 1,
            gapTime: row.gapTime,
            published: 1,
            remark: row.remark
        }))
      })

      return { nextOrder, roundPayload, buildBatchPayload }
    },

    saveRoundWithResults(round) {
      const payload = this.buildRoundSavePayload(round)
      return saveDragonRound(payload.roundPayload).then(res => {
        const savedRound = res.data || {}
        round.id = savedRound.id || round.id
        round.roundOrder = savedRound.roundOrder || payload.nextOrder

        return batchSaveDragonResults(payload.buildBatchPayload(round))
      })
    },

    // 统一保存当前录入页全部比赛组
    handleSaveAllRounds() {
      if (!this.roundCards.length) {
        this.$message.warning('暂无比赛组可保存')
        return
      }
      const invalidIndex = this.roundCards.findIndex((round, index) => !this.validateRoundBeforeSave(round, index))
      if (invalidIndex !== -1) {
        return
      }
      this.allSaving = true
      this.roundCards.reduce((promise, round) => {
        return promise.then(() => this.saveRoundWithResults(round))
      }, Promise.resolve()).then(() => {
        this.$message.success('全部比赛组保存成功')
        this.loadRoundsAndResults()
      }).catch(err => {
        this.$message.error(err.message || '保存失败')
      }).finally(() => {
        this.allSaving = false
      })
    },

    // 添加一个 Round 大格子
    handleAddNewRound() {
      const round = {
        tempId: `temp_${Date.now()}`,
        eventId: parseInt(this.eventId),
        categoryId: undefined,
        roundName: undefined,
        roundOrder: this.getNextRoundOrder(),
        roundTimeStr: this.getDefaultRoundDateTime(),
        status: 0,
        distance: undefined,
        description: '',
        results: [],
        participantTeams: []
      }
      this.roundCards.unshift(round)
    },

    handleDeleteRound(round) {
      if (!round.id) {
        this.roundCards = this.roundCards.filter(item => item !== round)
        return
      }
      deleteDragonRound({ id: round.id }).then(() => {
        this.$message.success(`第 ${round.roundOrder} 组已删除`)
        this.loadRoundsAndResults()
      }).catch(err => {
        this.$message.error(err.message || '删除本组失败')
      })
    },

    getNextRoundOrder() {
      if (!this.roundCards.length) {
        return 1
      }
      return Math.max(...this.roundCards.map(item => item.roundOrder || 0)) + 1
    },

    getDefaultRoundDateTime() {
      const latest = this.roundCards
        .map(item => item.roundTimeStr || (item.roundTime ? String(item.roundTime).slice(0, 16).replace('T', ' ') : ''))
        .filter(Boolean)
        .sort()
        .pop()
      if (latest) {
        return latest
      }
      return `${this.getEventStartDate()} 09:00`
    },

    calculateNextTime(lastTime) {
      if (!lastTime || !lastTime.includes(':')) return '09:00'
      const parts = lastTime.split(':')
      let hour = parseInt(parts[0]) || 9
      let min = parseInt(parts[1]) || 0
      min += 8
      if (min >= 60) {
        hour += Math.floor(min / 60)
        min = min % 60
      }
      if (hour >= 24) {
        hour = hour % 24
      }
      return `${String(hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`
    },

    // ==================== 组别管理部分 ====================
    handleAddCategory() {
      this.categoryForm = {
        eventId: parseInt(this.eventId),
        status: 1,
        sortOrder: 0,
        categoryName: ''
      }
      this.categoryVisible = true
    },
    handleEditCategory(record) {
      this.categoryForm = { ...record }
      this.categoryVisible = true
    },
    openRoundLineup(round) {
      this.lineupTeams = []
      this.activeLineupTeam = null
      this.lineupTitle = `坐舱名单 · ${round.roundName || '比赛组'}${round.distance ? '（' + round.distance + '米）' : ''}`
      this.lineupVisible = true
      getDragonRegistrationRoundLineups({
        eventId: this.eventId,
        roundId: round.id,
        categoryId: this.filter.categoryId
      }).then(res => {
        this.lineupTeams = res.data.teams || []
        this.boatSeatRows = res.data.boatSeatRows || []
        this.activeLineupTeam = this.lineupTeams[0] || null
        if (res.data.roundName) {
          this.lineupTitle = `坐舱名单 · ${res.data.roundName}`
        }
      })
    },
    handleSaveCategory() {
      this.$refs.categoryFormRef.validate(valid => {
        if (!valid) return
        saveDragonCategory(this.categoryForm).then(() => {
          this.$message.success('组别保存成功')
          this.categoryVisible = false
          this.loadCategories()
        }).catch(err => {
          this.$message.error(err.message || '保存组别失败')
        })
      })
    },
    handleDeleteCategory(id) {
      deleteDragonCategory({ id }).then(() => {
        this.$message.success('组别删除成功')
        this.loadCategories()
        this.loadRoundsAndResults()
      }).catch(err => {
        this.$message.error(err.message || '组别已有报名或成绩数据，不可删除')
      })
    },
    getCategoryName(categoryId) {
      const item = this.categories.find(c => c.id === categoryId)
      return item ? item.categoryName : '未分组'
    },
    getRoundTitle(round) {
      const parts = []
      if (round.categoryId) {
        parts.push(this.getCategoryName(round.categoryId))
      }
      if (round.distance) {
        parts.push(`${round.distance}米`)
      }
      if (round.roundName) {
        parts.push(round.roundName)
      }
      return parts.length ? parts.join(' ') : '请选择组别、阶段和距离'
    },
    getEventStartDate() {
      if (this.eventInfo && this.eventInfo.eventStartDate) {
        return this.eventInfo.eventStartDate
      }
      if (this.eventInfo && this.eventInfo.eventTime) {
        return this.eventInfo.eventTime.slice(0, 10)
      }
      return new Date().toISOString().slice(0, 10)
    },
    handleAddEventTeam() {
      this.teamForm = {
        eventId: parseInt(this.eventId),
        categoryId: this.filter.categoryId,
        teamId: undefined,
        bibNo: ''
      }
      this.teamVisible = true
    },
    handleSaveEventTeam() {
      if (!this.teamForm.categoryId || !this.teamForm.teamId) {
        this.$message.warning('请选择组别和队伍')
        return
      }
      addDragonRegistrationTeam(this.teamForm).then(() => {
        this.$message.success('队伍已加入赛事')
        this.teamVisible = false
        this.registrationReloadKey++
        this.loadTeamConfig()
        this.loadRoundsAndResults()
      }).catch(err => {
        this.$message.error(err.message || '加入队伍失败')
      })
    },
    handleReviewEventTeam(record, auditStatus) {
      auditDragonRegistration({
        registrationId: record.id,
        auditStatus,
        auditRemark: auditStatus === 1 ? '后台审核通过' : '后台审核拒绝',
        bibNo: record.bibNo
      }).then(() => {
        this.$message.success('队伍状态已更新')
        this.loadTeamConfig()
        this.loadRoundsAndResults()
      })
    },
    handleDeleteEventTeam(record) {
      deleteDragonRegistration({ registrationId: record.id }).then(() => {
        this.$message.success('队伍已从本赛事删除')
        this.loadTeamConfig()
        this.loadRoundsAndResults()
      }).catch(err => {
        this.$message.error(err.message || '删除队伍失败')
      })
    },
    registrationStatusColor(status) {
      if (status === 1) return 'green'
      if (status === 2) return 'red'
      return 'orange'
    },
    registrationStatusText(status) {
      const labels = { 0: '待审核', 1: '已通过', 2: '已拒绝' }
      return labels[status] || '未知'
    },
    handleAddStage() {
      this.stageForm = {
        eventId: parseInt(this.eventId),
        stageName: '',
        stageOrder: this.stageOptions.length + 1,
        status: 1
      }
      this.stageVisible = true
    },
    handleEditStage(record) {
      this.stageForm = { ...record }
      this.stageVisible = true
    },
    handleSaveStage() {
      if (!this.stageForm.stageName) {
        this.$message.warning('请输入阶段名称')
        return
      }
      saveDragonStageConfig(this.stageForm).then(() => {
        this.$message.success('阶段保存成功')
        this.stageVisible = false
        this.loadStageConfigs().then(() => {
          this.loadRoundsAndResults()
        })
      }).catch(err => {
        this.$message.error(err.message || '保存阶段失败')
      })
    },
    handleDeleteStage(id) {
      deleteDragonStageConfig({ id }).then(() => {
        this.$message.success('阶段删除成功')
        this.loadStageConfigs().then(() => {
          this.loadRoundsAndResults()
        })
      })
    },
    handleAddDistance() {
      this.distanceForm = {
        eventId: parseInt(this.eventId),
        distance: undefined,
        distanceOrder: this.distanceOptions.length + 1,
        status: 1
      }
      this.distanceVisible = true
    },
    handleEditDistance(record) {
      this.distanceForm = { ...record }
      this.distanceVisible = true
    },
    handleSaveDistance() {
      if (!this.distanceForm.distance) {
        this.$message.warning('请输入比赛距离')
        return
      }
      saveDragonDistanceConfig(this.distanceForm).then(() => {
        this.$message.success('距离保存成功')
        this.distanceVisible = false
        this.loadDistanceConfigs().then(() => {
          this.loadRoundsAndResults()
        })
      }).catch(err => {
        this.$message.error(err.message || '保存距离失败')
      })
    },
    handleDeleteDistance(id) {
      deleteDragonDistanceConfig({ id }).then(() => {
        this.$message.success('距离删除成功')
        this.loadDistanceConfigs().then(() => {
          this.loadRoundsAndResults()
        })
      })
    },
    statusColor(status) {
      const colors = { 0: 'orange', 1: 'blue', 2: 'green', 3: 'default', 4: 'gold' }
      return colors[status] || 'default'
    },
    statusText(status) {
      const labels = { 0: '准备阶段', 1: '报名阶段', 2: '比赛阶段', 3: '已结束', 4: '报名截止，待开赛' }
      return labels[status] || '未知'
    },
    rankBadgeClass(rankNo) {
      if (rankNo === 1) return 'rank-badge-1'
      return ''
    },
    formatRankNo(rankNo, isInvalid) {
      if (isInvalid) return '--'
      return rankNo || '-'
    },
    gapTimeClass(rankNo, isInvalid) {
      if (isInvalid) return 'gap-time-label'
      if (rankNo === 1) return 'gap-time-label gap-best'
      return 'gap-time-label gap-other'
    },
    formatGapText(gapTime, isInvalid) {
      if (isInvalid) return '--'
      return gapTime || '-'
    }
  }
}
</script>

<style scoped>
.workbench-header {
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border: 1px solid #e8eaf0;
}

.workbench-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
  border: 1px solid #e8eaf0;
  overflow: hidden;
}

/* 筛选项样式 */
.filter-bar {
  padding: 24px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  display: block;
}

/* 按钮样式扩展 */
.btn-success {
  background-color: #10b981;
  border-color: #10b981;
}
.btn-success:hover, .btn-success:focus {
  background-color: #059669;
  border-color: #059669;
}

/* 大格子（比赛组）盒子 */
.round-card-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 28px;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.03);
  overflow: hidden;
}

.round-card-header {
  background: #ffffff;
  padding: 14px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0f172a;
  flex-wrap: wrap;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-badge {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #e2e8f0;
}

.group-title {
  font-size: 16px;
  font-weight: 600;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.meta-field {
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-label {
  color: #64748b;
  font-size: 12px;
}

.btn-round-delete {
  color: #ef4444;
  border-color: #fecaca;
}

.btn-round-delete:hover {
  color: #dc2626;
  border-color: #dc2626;
}

/* 大格子内录入表格 */
.round-table-container {
  padding: 0;
}

.rapid-entry-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.rapid-entry-table th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 10px 16px;
  font-size: 13px;
  border-bottom: 1px solid #e2e8f0;
}

.rapid-entry-table td {
  padding: 8px 16px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.row-action-cell {
  text-align: center;
  white-space: nowrap;
}

.drag-handle {
  color: #64748b;
  cursor: move;
  font-size: 16px;
  margin-right: 14px;
}

.drag-handle:hover {
  color: #1890ff;
}

/* 行被标记为犯规或DNS时的底色 */
.row-foul-dns {
  background-color: #fff1f2;
}

/* 名次和差值角标 */
.rank-badge {
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
}
.rank-badge-1 {
  color: #10b981;
}

.gap-time-label {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
}
.gap-best {
  background-color: #d1fae5;
  color: #065f46;
}
.gap-other {
  background-color: #ffedd5;
  color: #9a3412;
}

/* 卡片底部动作栏 */
.round-card-footer {
  background: #fafafa;
  border-top: 1px solid #e2e8f0;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-left {
  font-size: 14px;
  color: #475569;
}

.btn-main-publish {
  background-color: #fff;
  border-color: #cbd5e1;
  border-radius: 6px;
  font-weight: 600;
  color: #334155;
  padding: 0 24px;
}
.btn-main-publish:hover {
  color: #2563eb;
  border-color: #2563eb;
}

/* ---------- 坐舱名单弹窗 ---------- */
.lineup-layout {
  display: flex;
  gap: 20px;
  min-height: 320px;
}

.lineup-team-list {
  width: 200px;
  flex-shrink: 0;
  border-right: 1px solid #E4EDF2;
  padding-right: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.lineup-team-item {
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 8px;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.lineup-team-item:hover {
  background: #F4FAFA;
}

.lineup-team-item.active {
  background: #E6F7F5;
  border-color: #4ECDC4;
}

.lineup-team-name {
  font-size: 14px;
  font-weight: 600;
  color: #16232F;
}

.lineup-team-meta {
  font-size: 12px;
  color: #7A8A9A;
  margin-top: 2px;
  display: flex;
  gap: 8px;
}

.lineup-boat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 8px;
  background: linear-gradient(180deg, #F2FAF9, #E8F4F2);
  border-radius: 10px;
  overflow-y: auto;
}

.boat-head, .boat-tail {
  font-size: 12px;
  color: #7A8A9A;
  letter-spacing: 3px;
  background: #fff;
  border-radius: 14px;
  padding: 3px 20px;
}

.boat-row {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: nowrap;
}

.boat-seat {
  width: 116px;
  padding: 10px 8px;
  background: #fff;
  border: 1px solid #DCEBE8;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(22, 35, 47, 0.06);
}

.boat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4ECDC4, #2FBFB5);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.boat-seat-name {
  font-size: 13px;
  color: #16232F;
  font-weight: 600;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.boat-seat-pos {
  font-size: 11px;
  color: #4ECDC4;
}

.boat-alternates {
  width: 100%;
  max-width: 340px;
  border-top: 1px dashed #E4EDF2;
  margin-top: 8px;
  padding-top: 10px;
}

.boat-alt-title {
  font-size: 12px;
  color: #7A8A9A;
  margin-bottom: 6px;
}

.boat-alt-item {
  font-size: 13px;
  color: #2C3A4B;
  padding: 3px 0;
}

.boat-empty {
  color: #999;
  font-size: 13px;
  padding: 30px 0;
}
</style>
